import { render, staticRenderFns } from "./DraftEnvelopesCardTable.vue?vue&type=template&id=a8b636f2&lang=pug"
import script from "./DraftEnvelopesCardTable.vue?vue&type=script&lang=js"
export * from "./DraftEnvelopesCardTable.vue?vue&type=script&lang=js"
import style0 from "./DraftEnvelopesCardTable.vue?vue&type=style&index=0&id=a8b636f2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports